<template>
    <v-card>
        <v-toolbar color="primary">
            <v-spacer></v-spacer>
            <v-toolbar-title style="color: white">
                {{ convenio_posto.convenio.nome_convenio }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
            <h3 class="subheading">Código:  <b>{{convenio_posto.convenio.codigo}}</b></h3>
            <h3 class="subheading">Número de conveniados:  <b>{{convenio_posto.convenio.cpfs_permitidos.length}}</b></h3>
            <h3 class="subheading">Desconto:  <b>{{ convenio_posto.desconto_reais !== null ? `R$ ${convenio_posto.desconto_reais}`: `${convenio_posto.desconto}%` }}</b></h3>
            <template v-if="convenio_posto.convenio.instituicao_representante">
                <div>
                    <h3 class="subheading">{{convenio_posto.convenio.instituicao_representante.tipo}} representante: <b>{{ convenio_posto.convenio.instituicao_representante.nome }}</b></h3>
                    <h3 class="subheading">CNPJ: <b>{{ convenio_posto.convenio.instituicao_representante.cnpj }}</b></h3>
                    <h3 class="subheading">Telefone: <b>{{ convenio_posto.convenio.instituicao_representante.telefone }}</b></h3>
                </div>
            </template>
        </v-card-text>
        <v-card-actions class="justify-center">
            <v-btn text @click="$emit('fechar')">Fechar</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>

export default {
  props: ['convenio_posto']
}

</script>
